import StringFieldRenderer from "@crispico/foundation-react/entity_crud/fieldRenderers/StringFieldRenderer";
import { FieldRendererProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { MissionEvent } from "types";
import { Button, Modal, Form, TextArea } from "semantic-ui-react";
import React from "react";
import { AssociationFieldEditor } from "@crispico/foundation-react/entity_crud/fieldEditors/AssociationFieldEditor";
import { FieldEditorProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { FieldDescriptor } from "@crispico/foundation-react";
import { NavLink } from "react-router-dom";
import { Label } from "semantic-ui-react";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { FilterOperators } from "@crispico/foundation-gwt-js";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";

export class MissionEvent_ObservationFieldRenderer extends StringFieldRenderer<FieldRendererProps, { showObservationModal: boolean; observationData: string }> {

    constructor(props: FieldRendererProps) {
        super(props);
        this.state = {
            showObservationModal: false,
            observationData: ""
        };
    }

    private clickHandlerObservationButton(entity: MissionEvent) {
        this.setState({
            showObservationModal: true,
            observationData: entity.observation || ""
        });
    }

    private renderObservationModal() {
        return (
            <Modal open={this.state.showObservationModal} onClose={() => this.setState({ showObservationModal: false })}>
                <Modal.Header>Observation</Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field>
                            <label>Observation Details</label>
                            <TextArea
                                value={this.state.observationData}
                                onChange={(e, { value }) => this.setState({ observationData: value as string })}
                                placeholder="Enter observation details..."
                                rows={4}
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        positive
                        onClick={() => {
                            // TODO: Save observation data
                            console.log("Saving observation:", this.state.observationData);
                            this.setState({ showObservationModal: false });
                        }}
                    >
                        {_msg("general.save")}
                    </Button>
                    <Button onClick={() => this.setState({ showObservationModal: false })}>
                        {_msg("general.cancel")}
                    </Button>

                </Modal.Actions>
            </Modal>
        );
    }

    render() {
        const event = this.props.entity as MissionEvent;

        return (
            <>
                <div className='flex-container-row flex-center justify-content-space-between gap5'>
                    {event.observation}
                    <Button icon="signup" onClick={() => this.clickHandlerObservationButton(event)} />
                </div>
                {this.renderObservationModal()}
            </>
        );
    }
}

export class MissionEvent_MessagesFieldRenderer extends StringFieldRenderer<FieldRendererProps, {}> {

    render() {
        const event = this.props.entity as MissionEvent;
        const isUnread = event.status === "unread";
        const styles = {
            fontWeight: isUnread ? 'bold' as const : 'normal' as const,
            color: isUnread ? 'red' : 'inherit'
        };

        return (
            <div style={styles}>
                {`${event.userName}: ${event.message}`}
                <br />
                {`${event.driver}: ${event.status === "No answer" || !event.answer ? "-" : event.answer}`}
            </div>
        );
    }
}

export class ObjectIdFieldDescriptor extends FieldDescriptor {

    protected renderFieldInternal(_: any, __: any, entity: any) {
        if (!entity.objectId) {
            return null;
        }
        const ed = entityDescriptors["Task"];
        return <NavLink key={entity.id + "_" + entity.objectId} to={ed.getEntityEditorUrl(entity.objectId)}>
            <Label data-position="top center">{ed.name + ":" + entity.objectId}</Label>
        </NavLink>;
    }

    protected renderFieldEditorInternal(_: any, props: FieldEditorProps): React.ReactElement {
        const missionId = props.formikProps?.values["missionId"];
        const fdTask = new FieldDescriptor();
        fdTask.name = "object";
        fdTask.type = "Task";
        return <AssociationFieldEditor
            isDisabled={!missionId}
            fieldDescriptor={fdTask}
            entity
            onChange={(task: any) => {
                if (task) {
                    props.formikProps?.setFieldValue(this.name, task.id);
                } else {
                    props.formikProps?.setFieldValue(this.name, null);
                }
            }}
            filter={Filter.create("mission.id", FilterOperators.forNumber.equals, missionId)} />
    }
}
